export function PublicPortfolioSkeleton() {
  return (
    <div
      className="kw-public-portfolio kw-public-portfolio--skeleton"
      role="status"
      aria-busy="true"
      aria-label="Loading portfolio"
    >
      <div className="kw-public-portfolio-skeleton-layout">
        <aside className="kw-public-portfolio-skeleton-sidebar">
          <div className="kw-public-portfolio-skeleton-avatar" />
          <div className="kw-public-skeleton-line wide title" />
          <div className="kw-public-skeleton-line medium" />
          <div className="kw-public-skeleton-line short" />
          <div className="kw-public-portfolio-skeleton-nav">
            <div className="kw-public-skeleton-line medium" />
            <div className="kw-public-skeleton-line medium" />
            <div className="kw-public-skeleton-line short" />
            <div className="kw-public-skeleton-line medium" />
          </div>
        </aside>
        <main className="kw-public-portfolio-skeleton-main">
          <div className="kw-public-skeleton-line section-title" />
          <div className="kw-public-skeleton-line wide" />
          <div className="kw-public-skeleton-line wide" />
          <div className="kw-public-skeleton-line medium" />
          <div className="kw-public-portfolio-skeleton-cards">
            <div className="kw-public-portfolio-skeleton-card" />
            <div className="kw-public-portfolio-skeleton-card" />
          </div>
          <div className="kw-public-skeleton-line section-title" />
          <div className="kw-public-skeleton-line wide" />
          <div className="kw-public-skeleton-line medium" />
          <div className="kw-public-skeleton-line short" />
        </main>
      </div>
      <span className="sr-only">Loading portfolio…</span>
    </div>
  );
}
